<script lang="ts" context="module">
	import { onMount } from "svelte";
	import { page } from "$app/stores";
</script>

<script lang="ts">
	const { isStaging, isDevelopment } = $page.data;

	let unmountToolbar: any;

	const MAX_RETRIES = 10;

	function initSentryToolbar(retryCount: number = 0) {
		if (!window.SentryToolbar) {
			if (retryCount >= MAX_RETRIES) {
				console.warn("Failed to initialize Sentry Toolbar after maximum retries");
				return;
			}
			setTimeout(() => initSentryToolbar(retryCount + 1), 500);
			return;
		}

		unmountToolbar = window.SentryToolbar.init({
			organizationSlug: "smore",
			projectIdOrSlug: "smore-app",
			environment: isStaging ? "staging" : isDevelopment ? "development" : "production",
			transactionToSearchTerm: (transactionName: any) => "*"
		});
	}

	onMount(() => {
		initSentryToolbar();

		return () => {
			if (unmountToolbar) {
				unmountToolbar();
			}
		};
	});
</script>

<svelte:head>
	<script src="https://browser.sentry-cdn.com/sentry-toolbar/latest/toolbar.min.js"></script>
</svelte:head>
